import { formatNetworkCurrency, formatQualityMeasureScore } from "@services/networkDashboardFormat";

export function formatPenaltyKind(kind: string | null | undefined): string {
  if (!kind) return "—";
  if (kind === "monetary_penalty") return "Monetary penalty";
  if (kind === "payment_denial") return "Payment denial";
  return kind.replace(/_/g, " ");
}

export function formatPenaltyCitationCodes(raw: unknown): string[] {
  if (raw == null) return [];
  const str = String(raw).trim();
  if (!str) return [];
  return str
    .split(/[;,]/)
    .map((part) => part.trim())
    .filter(Boolean);
}

export function formatStaffingMetric(value: unknown, decimals = 2): string {
  if (value == null || value === "") return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  const rounded = Math.round(num * 10 ** decimals) / 10 ** decimals;
  return rounded.toFixed(decimals).replace(/\.?0+$/, "");
}

export function staffingTabHasData(data: Record<string, unknown> | null | undefined): boolean {
  if (!data) return false;
  const staffing = (data.staffing ?? data) as Record<string, unknown>;
  const keys = [
    "adjusted_total_nurse_hprd",
    "adjusted_rn_hprd",
    "total_nursing_turnover",
    "rn_turnover",
    "administrator_turnover_count",
    "gap_vs_state_hprd",
    "gap_rn_hprd",
  ];
  return keys.some((key) => staffing[key] != null);
}

export function ownershipTabHasUsefulData(data: Record<string, unknown> | null | undefined): boolean {
  if (!data) return false;
  const ownership = (data.ownership ?? data) as { entries?: Record<string, unknown>[] };
  const entries = ownership.entries ?? [];
  return entries.some(
    (entry) => entry.ownership_percentage != null || entry.association_date != null,
  );
}

/** Optional detail tabs stay hidden until probed; only show when probe found useful data. */
export function isOptionalDetailTabVisible(probeResolved: boolean, hasUsefulData: boolean): boolean {
  return probeResolved && hasUsefulData;
}

export function formatQualityMeasureRows(
  measures: Record<string, unknown>[],
): Record<string, unknown>[] {
  return measures.map((row) => ({
    ...row,
    score: formatQualityMeasureScore(row.score as number | null | undefined),
    measure_name: row.measure_name ?? row.measure_code ?? "—",
    flag: row.flag ?? "—",
  }));
}

export { formatNetworkCurrency, formatQualityMeasureScore };
